import React, { useState, useEffect } from "react";
import Pagination from "../common/Pagination";
import ApiService from "../../Service/ApiService";
import RoomResult from "../common/RoomResult";
import RoomSearch from "../common/RoomSearch";
import { useLocation } from "react-router-dom";
import Header from "../common/Header";

const AllRoomsPage = () => {
  const [rooms, setRooms] = useState([]);
  const [filteredRooms, setFilteredRooms] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [roomsPerPage] = useState(5);
  const [currency, setCurrency] = useState("USD");
  const [searchDates, setSearchDates] = useState({ checkInDate: null, checkOutDate: null });
  const location = useLocation();

  // Function to handle search results
  const handleSearchResult = (results, checkInDate, checkOutDate) => {
    setRooms(results);
    setFilteredRooms(results);
    if (checkInDate && checkOutDate) {
      setSearchDates({ checkInDate, checkOutDate });
    }
  };

  useEffect(() => {
    const fetchRooms = async () => {
      let hotelId = location?.state?.id;
      let response;
      if (hotelId) response = await ApiService.getAllRooms(hotelId);
      else response = await ApiService.getAllRooms();

      setRooms(response);
      setFilteredRooms(response);
    };

    const fetchRoomTypes = async () => {
      try {
        const types = await ApiService.getRoomTypes();
        setRoomTypes(types);
      } catch (error) {
        console.error("Error fetching room types:", error?.message || error);
      }
    };
    let currency = location?.state?.currency;
    if (currency) setCurrency(currency);
    fetchRooms();
    fetchRoomTypes();
  }, [location?.state?.id, location?.state?.currency]);

  const handleRoomTypeChange = (e) => {
    setSelectedRoomType(e.target.value);
    filterRooms(e.target.value);
  };

  const filterRooms = (type) => {
    if (type === "") {
      setFilteredRooms(rooms);
    } else {
      const filtered = rooms.filter((room) => room.roomType === type);
      setFilteredRooms(filtered);
    }
    setCurrentPage(1); // Reset to first page after filtering
  };

  //Pagination
  const indexOfLastRoom = currentPage * roomsPerPage;
  const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
  const currentRooms = filteredRooms.slice(indexOfFirstRoom, indexOfLastRoom);

  //Change page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="all-rooms">
      <Header title={"All Rooms"} />
      <div className="all-room-filter-div">
        <label>Filter by Room Type: </label>
        <select value={selectedRoomType} onChange={handleRoomTypeChange}>
          <option value="">All</option>
          {roomTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div>
      <RoomSearch handleSearchResult={handleSearchResult} />
      <RoomResult roomSearchResults={currentRooms} currency={currency} searchDates={searchDates} />

      <Pagination
        roomsPerPage={roomsPerPage}
        currentPage={currentPage}
        totalRooms={filteredRooms.length}
        paginate={paginate}
      />
    </div>
  );
};

export default AllRoomsPage;
